import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Header.css'; // Import the CSS file for styling

const Header = ({logo}) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogoClick = () => {
        // Get locale from URL query params
        const queryParams = new URLSearchParams(location.search);
        const locale = queryParams.get('locale') || 'en_US';

        // Navigate based on locale
        if (locale === 'en_CA') {
            navigate('/cad');
        } else {
            navigate('/usd');
        }
    };

    return (
        <header className="header-container">
            {/* Company Logo */}
            <img
                src={logo}
                alt="Company Logo"
                className="header-logo"
                onClick={handleLogoClick}
                style={{ cursor: 'pointer' }}
            />
        </header>
    );
};

export default Header;
